import {
  IPublicClientApplication,
  PublicClientApplication,
  InteractionType,
  BrowserCacheLocation,
  LogLevel,
} from "@azure/msal-browser";
import { MsalInterceptorConfiguration, MsalGuardConfiguration } from "@azure/msal-angular";
import { apiConfig, b2cPolicies } from "./aad-b2c-config";
import { environment } from "../../../environments/environment";

export function loggerCallback(logLevel, message) {
  console.log(message);
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.msal.AzureClientId,
      authority: b2cPolicies.authorities.signUpSignIn.authority,
      redirectUri: "/",
      postLogoutRedirectUri: "/",
      knownAuthorities: [`${environment.msal.AzureB2CName}.b2clogin.com`],
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
    },
    system: {
      allowPlatformBroker: false, // Disables WAM Broker
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Warning,
        piiLoggingEnabled: false,
      },
    },
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map([
    [
      `${environment.API_BASE_URL}/secure/*`,
      [
        `${environment.msal.AzureB2CAPIApplicationIdUri}/API.Blocklist.Manage`,
        `${environment.msal.AzureB2CAPIApplicationIdUri}/API.Notifications.Manage`,
      ],
    ],
  ]);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: protectedResourceMap,
    authRequest: { redirectUri: environment.FrontendBaseUrl },
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [...apiConfig.scopes],
    },
  };
}
